import { GfsOfferEditor } from "@/services/backend/gfs/offer/components/offer-editor";

export default function GfsOfferRoute() {
  return <GfsOfferEditor />;
}
